<template>
  <b-container class="buttons-box-main-cnt">
    <!-- Button Box -->
    <div
      v-for="buttonCard in buttonCards"
      :key="buttonCard.subtitle"
      class="button-cnt"
    >
      <b-button
        class="circle-button box-button"
        @click="handleFunction(buttonCard.onClick)"
        :href="buttonCard.siteLink"
      >
        <div class="button-img-cnt">
          <img :src="buttonCard.imgSrc" :alt="buttonCard.imgAlt" />
        </div>
      </b-button>
      <h3 class="button-subtitle">{{ buttonCard.subtitle }}</h3>
    </div>
    <!-- VS Box -->
    <b-container class="vs-box-main-cnt">
      <img
        class="team-logo"
        src="@/assets/images/icons/buttons-box/colts.svg"
        alt="Colts"
      />
      <h4 class="vs-text">VS</h4>
      <img
        class="team-logo"
        src="@/assets/images/icons/buttons-box/cardinals-Logo.svg"
        alt="Cardinals"
      />
    </b-container>
  </b-container>
</template>

<script>
import { homeButtons } from "@/assets/data/homeButtonsData.js";

export default {
  name: "ButtonsBox",
  data() {
    return {
      buttonCards: homeButtons,
    };
  },
  methods: {
    ImagetoPrint(source) {
      return (
        "<html><head><script>function step1(){\n" +
        "setTimeout('step2()', 100);}\n" +
        "function step2(){window.print();window.close()}\n" +
        "</scri" +
        "pt></head><body onload='step1()'>\n" +
        "<img src='" +
        source +
        "' /></body></html>"
      );
    },
    printMap() {
      //   let source =
      //     "https://cardinals.vipfanportal.com/2021holidays/files/Cardinalville_-min.jpg";
      let newWindow = window.open(
        "https://cardinals.vipfanportal.com/2021holidays/files/Cardinalville_frame.png"
      );
      newWindow.print();
    },
    downloadMap() {
      var el = document.createElement("a");
      el.setAttribute(
        "href",
        "https://cardinals.vipfanportal.com/2021holidays/files/Cardinalville_frame.png"
      );
      el.setAttribute("download", "CardinalvilleHolidayMap.png");
      document.body.appendChild(el);
      el.click();
      el.remove();
    },
    showShareModal() {
      this.$store.dispatch("showShareModal");
    },
    handleFunction(functionName) {
      this[functionName]();
    },
  },
};
</script>

<style lang="scss" scoped>
.buttons-box-main-cnt {
  height: 310px;
  max-width: 1000px;
  border-radius: 4px;
  background: linear-gradient(180deg, #e4e5e4 0%, #cecece 100%);
  box-shadow: 0 6px 30px 0 rgba(16, 0, 0, 0.1);
  margin-top: 33px;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 40px;
  position: relative;
  .button-cnt {
    margin-top: 38px;
  }
  .vs-box-main-cnt {
    height: 120px;
    max-width: 300px;
    border-radius: 4px;
    background: linear-gradient(0deg, #f2f2f2 0%, #ffffff 100%);
    box-shadow: 0 6px 30px 0 rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    position: absolute;
    bottom: -70px;
    .vs-text {
      color: $grey;
      font-family: Gotham;
      font-size: 14px;
      font-weight: 900;
      letter-spacing: 2.8px;
      line-height: 24px;
      text-align: center;
      margin: 0 0 0 12px;
    }
    .team-logo {
      filter: drop-shadow(0 5px 26px 0 rgba(0, 0, 0, 0.2));
    }
  }
}
@media only screen and (max-width: $lg) {
  .buttons-box-main-cnt {
    flex-wrap: wrap;
    row-gap: 10px;
    align-items: flex-start;
    align-content: flex-start;
    height: 385px;
    .button-cnt {
      flex-basis: calc(33% - 56px);
      gap: 10px;
      margin-top: 10px;
      .box-button {
        .button-img-cnt {
          img {
            width: 100px;
            height: auto;
          }
        }
      }
    }
  }
}
@media only screen and (max-width: $sm) {
  .buttons-box-main-cnt {
    height: 600px;
    flex-wrap: wrap;
    row-gap: 20px;
    align-items: flex-start;
    align-content: center;
    .button-cnt {
      flex-basis: calc(50% - 56px);
      gap: 10px;
      margin-top: 10px;
      .box-button {
        .button-img-cnt {
          img {
            width: 104px;
            height: auto;
          }
        }
      }
    }
    .vs-box-main-cnt {
      max-width: 576px;
      bottom: -170px;
    }
  }
}
</style>
